import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { DataTypes, Vehicle } from '@sm360/widget-commons-vehicle';

import SpecificationLine from './SpecificationLine.jsx';

const { VehicleModel } = Vehicle;

const optionIsColorOption = (option) => {
    return (
        option.dataType === DataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID &&
        (option.typeID === DataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR ||
            option.typeID === DataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM)
    );
};

const Specification = ({ vehicle }) => {
    const selectedPackage = vehicle.purchaseMethods.getSelectedOptionsPackage();
    const selectedOptions = vehicle.purchaseMethods.getSelectedOptionsAndColours();

    const packageItems =
        !!selectedPackage.length &&
        selectedPackage
            .map(
                (pck) =>
                    !!pck.description && <SpecificationLine key={`package-${pck.code}`} description={pck.description} />
            )
            // filter out package with no description
            // they are considered base package, not worth of displaying
            .filter((value) => !!value);

    const colorOptions = selectedOptions.filter((option) => optionIsColorOption(option) && option.retail > 0);
    const colorItems =
        !!colorOptions.length &&
        colorOptions.map((option) => (
            <SpecificationLine key={`color-${option.code}`} description={option.description} />
        ));

    const otherOptions = selectedOptions.filter(
        (option) => !optionIsColorOption(option) && !option.isConfigurationOption
    );
    const optionsCountString =
        otherOptions.length > 1
            ? LocaleService.t('SUMMARY.OPTION_COUNT_PLURAL', { count: otherOptions.length })
            : LocaleService.t('SUMMARY.OPTION_COUNT_SINGLE');
    const optionItems = !!otherOptions.length && <SpecificationLine key="options" description={optionsCountString} />;

    if (!packageItems.length && !colorOptions.length && !otherOptions.length) {
        // render an empty <p> tag to keep the preview image aligned on the right
        return <p />;
    }

    return (
        <div className="listing-tile-specification-wrapper">
            <p className="listing-tile-package-head is-bold is-uppercase is-price sr-disclaimer">
                {LocaleService.t('SUMMARY.OPTION_HEADER')}
            </p>
            {packageItems}
            {optionItems}
            {colorItems}
        </div>
    );
};

Specification.propTypes = {
    vehicle: PropTypes.instanceOf(VehicleModel).isRequired,
};

Specification.displayName = 'NewTile.Specification';

export default Specification;



// WEBPACK FOOTER //
// /builds/development/frontend/widgets/widgets/components/tiles/tile-a/src/components/Tile/InventoryNew/Specification/Specification.jsx